var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex mt-4"},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("mdi-card-text-outline")]),_c('p',{directives:[{name:"linkify",rawName:"v-linkify"}],staticClass:"mb-0 ml-2 text-body-1 blue--text overflow-hidden"},[_vm._v("\n    "+_vm._s(_vm.$sanitize(_vm.response, { allowedTags: ['a'] }))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }